import { NotificationManager } from "../../components/common/react-notifications";
import _axios from "../../libs/axios";
import { cloneDeep } from "lodash"

export default (context) => {
  context.refreshData = function () {
    _axios
      .get('admEvalConcept/get/?PageSize=40&isBehavior=' + this.state.formFilter.isBehavior + '&activityId=' + this.props.filterBy.activityId + '&page=1')
      .then(r => {
        if (r.status >= 0) {
          let data = this.sortConcept(r.data.Results)
          this.setState({data: data})
        }
        NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
      }).catch((e) => { this.props.setLoader(false) })
  }

  context.sortConcept = function (data) {
    data.map(e => {
      e.editRow = this.getDataById
      e.deleteRow = this.toggleDelete
      e.moveConcept = this.moveConcept
      e.levelTxt = (e.level + 1)
      e.hidden = !e.hidden
      return e
    })

    let order = []
    var maxLevel = Math.max.apply(Math, data.map(function(o) { return o.level; }));
    // ordeno el array segun level
    for(let i = 0; i<=maxLevel; i++) {
      order = order.concat(data.filter((e) => { return e.level === i }).sort((a, b) => { return a.order - b.order })) // ordeno segun order
    }
    // ordenar segun jerarquía
    let items = []
    let index = 0
    items = order.filter(e => e.parentId === null)
    if (items.length > 0) {
      let f = () => {
        if (items.length === order.length) return
        order.forEach((e) => {
          if (e.parentId === items[index].ID) items.splice(index + (items.filter(e => e.parentId === items[index].ID).length + 1), 0, e)
        });
        index++
        f()
      }
      f()
    }

    return items
  }

  context.moveConcept = function (item, move) {
    // console.log(this.state.data)
    const footprint = cloneDeep(this.state.data)
    let data = cloneDeep(this.state.data)
    if (move === 'up')
    {
      let index = data.findIndex(e => e.ID === item.ID)
      let brothers = data.filter(e => e.parentId === item.parentId)
      let indexAsBrother = brothers.findIndex(e => e.ID === item.ID)
      if (index === 0 || indexAsBrother === 0) return NotificationManager.error("No se puede mover '"+item.name+"' más arriba", "No se ha movido el concepto", 3000, null, null, 'outline')

      else {
        /*
        const indexOfBrother = data.findIndex(e => e.ID === brothers[indexAsBrother - 1].ID)
        const temp1 = data[index].order
        const temp2 = data[indexOfBrother].order
        data[indexOfBrother].order = temp1
        */
        data[index].order = -1000
        // console.log(data[index].order)
      }
    }
    if (move === 'down')
    {
      let index = data.findIndex(e => e.ID === item.ID)
      let brothers = data.filter(e => e.parentId === item.parentId)
      let indexAsBrother = brothers.findIndex(e => e.ID === item.ID)
      if (((indexAsBrother + 1) === brothers.length)) return NotificationManager.error("No se puede mover '"+item.name+"' más abajo", "No se ha movido el concepto", 3000, null, null, 'outline')
      else {
        /*
        const indexOfBrother = data.findIndex(e => e.ID === brothers[indexAsBrother + 1].ID)
        const temp1 = data[index].order
        const temp2 = data[indexOfBrother].order
        data[indexOfBrother].order = temp1
        */
        data[index].order = 1000
        // console.log(data[index].order)
      }
    }
    if (move === 'left')
    {
      // get new parent or make parent
      let brothers = data.filter(e => e.parentId === item.parentId)
      // console.log(brothers)
      if (item.level === 0 || brothers[brothers.length - 1].ID !== item.ID) return NotificationManager.error("No se puede mover '"+item.name+"' a la izquierda, mueva primero los últimos de cada nivel", "No se ha movido el concepto", 3000, null, null, 'outline')
      data[data.findIndex(e => e.ID === item.ID)].parentId = item.level === 1 ? null : data[data.findIndex(e => e.ID === brothers[0].ID) - 1].parentId

      // change level
      let start = data.findIndex(e => e.ID === item.ID)
      let stop = data.findIndex((e, index1) => index1 > start && e.level <= item.level)
      stop = stop === -1 ? data.length : stop - 1

      // console.log(start, stop)
      data.forEach((e, index) => {
        if(index >= start && index <= stop) e.level = e.level - 1
      });
    }
    else if (move === 'right')
    {
      // get new parent
      let levels = data.filter(e => e.level === item.level)
      let index = levels.findIndex(e => e.ID === item.ID)
      let indexGroup = levels.filter(e => e.parentId === item.parentId).findIndex(e => e.ID === item.ID)
      if (index <= 0 || indexGroup <= 0)  return  NotificationManager.error("No se puede mover '"+item.name+"' más a la derecha", "No se ha movido el concepto", 3000, null, null, 'outline')
      else data[data.findIndex(e => e.ID === item.ID)].parentId = levels[index - 1].ID

      // change level
      let start = data.findIndex(e => e.ID === item.ID)
      let stop = data.findIndex((e, index1) => index1 > start && e.level <= item.level)
      stop = stop === -1 ? data.length : stop - 1

      // console.log(start, stop)
      data.forEach((e, index) => {
        if(index >= start && index <= stop) e.level = e.level + 1
      });
    }
    
    let order = []
    var maxLevel = Math.max.apply(Math, data.map(function(o) { return o.level; }));
    // ordeno el array segun level
    for(let i = 0; i<=maxLevel; i++) {
      order = order.concat(data.filter((e) => { return e.level === i }).sort((a, b) => { return a.order - b.order })) // ordeno segun order
    }
    // console.log(order)
    // ordenar segun jerarquía
    let res = []
    let index = 0
    res = order.filter(e => e.parentId === null)
    if (res.length > 0) {
      let f = () => {
        if (res.length === order.length) return
          order.forEach((e) => {
            if (e.parentId === res[index].ID) res.splice(index + (res.filter(e => e.parentId === res[index].ID).length + 1), 0, e)
          });
          index++
        f()
      }
      f()
    }
    
    res.map(e => e.levelTxt = (e.level+1))

    /*
    this.setState({data: r}, () => {
      this.props.setLoader(true)
      // console.log(this.state.data)
      const temp = cloneDeep(this.state.data)
      const save = (i) => {
        if  (i > (temp.length - 1)) {
          this.props.setLoader(false)
          return
        }
        const item = temp[i]
        delete item.moveConcept
        delete item.toggle
        delete item.toggleDelete
        delete item.name
        delete item.abrev
        item.grid = true
        // item.level = 0
        // item.order = 0
        // item.parentId = null
        _axios
          .post('admEvalConcept/edit/' + item.ID, item)
          .then(r => {
            if (r.status >= 0) {
              i = i + 1
              save(i)
            } else NotificationManager.error(r.msg, "Error", 5000, null, null, 'outline')
          }).catch((e) => { this.props.setLoader(false) })
      }
      save(0)
    })
    */

    this.props.setLoader(true)
    let temp = cloneDeep(res)
    temp = temp.filter(f => footprint.some(s=> s.ID === f.ID && (f.level!==s.level || f.order!==s.order || f.parentId!==s.parentId)))

    const save = (i) => {
      if  (i > (temp.length - 1)) {
        this.props.setLoader(false)
        this.refreshData()
        return
      }
      const item = temp[i]
      delete item.moveConcept
      delete item.toggle
      delete item.toggleDelete
      delete item.name
      delete item.abrev
      item.hidden = !item.hidden
      item.grid = true
      if (move === 'up') item.order = -1
      if (move === 'down') item.order = 1
      if (['left', 'right'].indexOf(move) > -1) delete item.order
      
      
      _axios
        .post('admEvalConcept/edit/' + item.ID, item)
        .then(r => {
          if (r.status >= 0) {
            /*
            let d = cloneDeep(res)
            d.map((e) => {
              if (e.ID === item.ID) e = item
              return e
            })
            this.setState({data: d})
            */
            i = i + 1
            save(i)
          }
          NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
        }).catch((e) => { this.props.setLoader(false) })
    }
    save(0)
  }

  return {
    config: {
      hiddenTitle: true,
      pageSize: 100,
      list: false,
      getDataSuccess: (data) => {
        let r = context.sortConcept(data)
        return r
      }
    },

    actions: {
      create: context.props.userAdmin.role === '100' ? {
        reloadGrid: true
      } : false,
      edit: {
        reloadGrid: true
      },
      delete: true,
      print: {
        local: true
      },
      export: {
        local: true
      }
    },

    extras: {
      maxActions: 0,
      itemsInRowsTable: (() => {
        let items = [
          {
            icon: 'simple-icon-plus', name: 'Agregar Nivel', onClick: (rowData, ctx) => {
              context.state.formFields.map((e) => {
                if (e.name === 'parentId') e.value = { value: rowData.ID, label: rowData.name }
                if (e.name === 'level') e.value = rowData.level + 1
                return e
              })
              context.toggle()
              setTimeout(() => { context.view.actions.create = {reloadGrid: true} }, 500)
            }
          },
          {
            icon: 'simple-icon-arrow-up-circle', name: 'Mover arriba', onClick: (rowData, ctx) => {
              ctx.moveConcept(rowData, 'up')
            }
          },
          {
            icon: 'simple-icon-arrow-down-circle', name: 'Mover abajo', onClick: (rowData, ctx) => {
              ctx.moveConcept(rowData, 'down')
            }
          },
          {
            icon: 'simple-icon-arrow-right-circle', name: 'Mover derecha', onClick: (rowData, ctx) => {
              ctx.moveConcept(rowData, 'right')
            }
          },
          {
            icon: 'simple-icon-arrow-left-circle', name: 'Mover izquierda', onClick: (rowData, ctx) => {
              ctx.moveConcept(rowData, 'left')
            }
          }
        ]
        return items
      })()
    },

    filter:{
      fields: [
        {
          name: "isBehavior",
          value: false,
          type: "select",
          label: "Tipo",
          opts: {
            style: 'float-label',
            items: [
              {
                value: false,
                label: "Notas"
              },
              {
                value: true,
                label: "Conducta"
              }
            ],
            isClearable: false
          },
          onChange: (ctx) => {
            if (ctx.state.isBehavior === context.state.formFilter.isBehavior) return
            process.nextTick(() => { context.resetDataTable() })
          }
        }
      ]
    },

    form: {
      remapOne: (r) => {
        if (r.status >= 0) {
          r.data.type = r.data.type + ''
          if (r.data.parentId) r.data.parentId = { value: r.data.parentId, label: r.data.parentName }
          // Set weightType based on weight value
          r.data.weightType = r.data.weight === 0 ? "none" : r.data.weight === -1 ? "auto" : "manual"
        }
        return r
      },
      setValuesBeforePost: (v) => {
        v.order = 0
        // Set weight to -1 if weightType is auto
        if (v.weightType === "auto") v.weight = -1
        else if (v.weightType === "none") v.weight = 0
        
        // create
        if (!context.state.idItemSelected) {
          v.activityId = context.props.filterBy.activityId
          v.ID = 0
          v.type = v.type || 0
        }

        if (v.parentId && v.parentId.value) v.parentId=v.parentId.value
        return v
      },
      fields: [
        {
          col: 6,
          name: "specialType",
          value: "",
          type: "select",
          label: "Tipo:",
          opts: {
            style: 'float-label',
            itemsF: () => {
              const r = context.state.formFilter.isBehavior ? 
              [
                {
                  value: "3",
                  label: "Conducta"
                },
                {
                  value: "4",
                  label: "Conducta Descriptiva"
                }
              ]
              :
              [
                {
                  value: "",
                  label: "Nota"
                },
                {
                  value: "2",
                  label: "Nota Descriptiva"
                },
                {
                  value: "5",
                  label: "Concepto > Unidad > Evaluación"
                }
              ]
             return r
            },
            isClearable: false
          },
          renderIf: (ctx) => !context.state.idItemSelected && ([0, "0"].indexOf(ctx.state.level) > -1)
        },
        {
          col: 12,
          name: "name",
          value: "",
          type: "text",
          label: "Concepto",
          hint:"Nombre del concepto",
          rules: 'required|max:400',
          opts: {
            style: 'float-label',
          }
        },
        {
          col: 12,
          name: "parentId",
          value: "",
          type: "select",
          label: "Concepto padre",
          parent: "specialType",
          opts: {
            style: 'float-label',
            path: (ctx) => { return "/admEvalConcept/get?pick=true&activityId=" + context.props.filterBy.activityId + "&isBehavior=" + ([3, "3"].indexOf(ctx.state.specialType) > -1 ? "true" : "false") },
           
          },
          renderIf: (ctx) => !context.state.idItemSelected,
          disabled: context.props.userAdmin.role !== '100'
        },
        {
          name: "level",
          value: "0",
          type: "hidden",
        },
        {
          name: "order",
          value: "",
          type: "hidden",
        },
        {
          col: 4,
          name: "abrev",
          value: "",
          type: "text",
          label: "Abreviación",
          rules: 'required|min:2|max:5',
          opts: {
            style: 'float-label',
          },
        },
        {
          name: "type",
          value: "",
          type: "hidden", //"select",
          label: "Tipo de evaluación",
          opts: {
            style: 'float-label',
            items: [
              {value: "0", label: "Cuantitativa"},
              {value: "1", label: "Cualitativa"}
            ],
            isClearable: false
          }
        },        
        {
          col: 5,
          name: "weightType",
          value: "auto",
          type: "select", 
          label: "Tipo de ponderación",
          rules: 'required',
          opts: {
            style: 'float-label',
            items: [
              {value: "auto", label: "% automático"},
              {value: "manual", label: "% manual"},              
              {value: "none", label: "Ninguna"}
            ],
            isClearable: false
          },
          renderIf: () =>  context.props.userAdmin.role === '100' 
        },
        {
          col: 3,
          name: "weight",
          value: "100",
          type: "number",
          label: "Ponderación (% del 1 al 100)",
          rules: 'required',
          opts: {
            style: 'float-label',
          },
          renderIf: (ctx) => ctx.state.weightType === "manual" && context.props.userAdmin.role === '100'
        },
        {
          col: 12,
          name: "separator1", 
          type: "separator"
        },
        {
          col: 12,
          name: "qualifications",
          value: "AD,A,B,C",
          type: "hidden", //"text",
          label: "Opciones de calificación cualitativa",
          hint: "Ingresar los caracteres cualitativos en orden de valor mayor a menor, separarlos por comas",
          opts: {
            style: 'float-label'            
          },
          renderIf: (ctx)=> ctx.state.type === "1"
        },
        {
          name: "locked",
          value: false,
          type: "switch",
          label: "Promedia según subconceptos",
          opts: {
            style: 'float-label'
          },
          renderIf: (ctx) => context.props.userAdmin.role === '100'
        },
        {
          col: 6,
          name: "canEdit",
          value: true,
          type: "switch",
          label: "Permitir editar a profesores del curso/sección",
          opts: {
            style: 'float-label'
          },
          renderIf: (ctx)=> context.props.userAdmin.role === '100' && ([0, "0"].indexOf(ctx.state.level) > -1)
        },
        {
          col: 6,
          name: "hidden",
          value: false,
          type: "switch",
          label: "Ocultar en libreta",
          opts: {
            style: 'float-label'
          },
          renderIf: () =>  context.props.userAdmin.role === '100' 
        }
      ]
    },

    columns: [
      {
        Header: "Nivel",
        accessor: "levelTxt",
        type: 'text',
        maxWidth: 50,
      },
      {
        Header: "Concepto",
        accessor: "name",
        type: 'concept',
        maxWidth: 350
      },
      {
        Header: "Abrev",
        accessor: "abrev",
        type: 'text',
        maxWidth: 60
      },
      {
        Header: "Tipo",
        accessor: "weight",
        type: 'chip',
        maxWidth: 80,
        chips: {
          '1': {text:'Promedio', color:'gray'},
          '-1': {text:'Ponderado', color:'gray'}
        },
      },
      {
        Header: "Valor",
        accessor: "weighted",
        type: 'text',
        maxWidth: 50
      },
      {
        Header: "Visible",
        accessor: "hidden",
        isBool: true,
        maxWidth: 60
      }
    ]
  }
}